<script lang="ts">
	//UI
	import { DefaultSwitch, AutoComplete } from "@hitit/new_ui";
	import StoreNameValue from "@hitit/hub/src/v7/components/store/StoreNameValue.svelte";
	//Utils
	import {
		getNationalPhonenumber,
		addSpacer,
	} from "@hitit/hub/src/functions/utils/phone";
	import { api, t } from "@hitit/hub/src/stores";

	//Types
	import type { AddressData } from "@hitit/api";

	//Props
	export let formattedAddress1 = "";
	export let formattedAddress2 = "";
	export let lat = 0;
	export let lng = 0;
	export let phonenumber = "";
	export let phonenumberCountryCode = "";
	export let cacheReceiptAvailable = "";
	export let type1 = "";
	export let type2 = "";
	export let detailAddress = "";
	export let appLockEnabled = false;
	export let smartpayAvailable = "";
	export let editmode = false;

	//Constants
	const autocompleteBackground = "#f0f0f4";
	//Variables
	let storePhonenumber = getNationalPhonenumber(
		phonenumber,
		phonenumberCountryCode
	);

	//Functions

	function autoCompleteHandler(type: "road" | "numb") {
		return async (search: string) => {
			try {
				const r = await $api.searchAddress(0, 0, search);
				const result = r.data.results;
				return result.map((v) => {
					return {
						name: type === "numb" ? v.formattedAddress2 : v.formattedAddress1,
						callback: () => setAddressData(v),
					};
				});
			} catch (error) {
				return [];
			}
		};
	}

	function setAddressData(addressData: AddressData) {
		formattedAddress1 = addressData.formattedAddress1;
		formattedAddress2 = addressData.formattedAddress2;
		lat = addressData.lat;
		lng = addressData.lng;
	}

	function onInput(e: Event) {
		const target = e.currentTarget as HTMLInputElement;
		const { value } = target;
		const originalCaret = target.selectionEnd;
		const originalGap = value.length - (originalCaret || 0);
		const replace = value
			.replace(/-/g, "") //"-"제거
			.replace(/[^0-9]/g, ""); //숫자를제거한 나머지 모두 제거
		const newValue = addSpacer(replace); //다시 addSpacer
		target.value = newValue;
		target.focus();

		//캐럿을 따로 설정해주지 않으면, target.value = newValue로 인해서 캐럿이 항상 마지막으로 이동한다.
		const newPosition = newValue.length - originalGap;
		target.setSelectionRange(newPosition, newPosition);

		storePhonenumber = replace;
		phonenumber = getNationalPhonenumber(replace);
	}

	function switchChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		smartpayAvailable = target.checked ? "TRUE" : "FALSE";
	}
	//Do
</script>

<div class="container" t-id="StoreAdditionalInfo">
	<div class="name-value">
		<StoreNameValue
			clearCallback={() => (storePhonenumber = "")}
			on:input={onInput}
			value={addSpacer(storePhonenumber)}
			name={$t("hub.store.storeinfo.store_number")}
			editmode={editmode}
		/>
	</div>
	<div class="name-value dummy" />
	<div class="name-value">
		<StoreNameValue
			description={$t("hub.store.widget.cashreceipt.tooltip")}
			name={$t("hub.store.widget.cashreceipt.title")}
			value={cacheReceiptAvailable === "TRUE"
				? $t("hub.store.widget.cashreceipt.enabled")
				: $t("hub.store.widget.cashreceipt.disabled")}
		/>
	</div>
	<div class="name-value">
		<StoreNameValue
			name={$t("hub.store.storeinfo.smartpay")}
			editmode={editmode}
			value={smartpayAvailable === "TRUE"
				? $t("hub.store.widget.cashreceipt.enabled")
				: $t("hub.store.widget.cashreceipt.disabled")}
		>
			<div slot="input" class="lock-box">
				<DefaultSwitch
					checked={smartpayAvailable === "TRUE"}
					on:change={switchChangeHandler}
				/>
			</div>
		</StoreNameValue>
	</div>
	<div class="name-value">
		<StoreNameValue name={$t("hub.store.storeinfo.category1")} value={type1} />
	</div>
	<div class="name-value">
		<StoreNameValue name={$t("hub.store.storeinfo.category2")} value={type2} />
	</div>
	<div class="name-value">
		<StoreNameValue
			editmode={editmode}
			name={$t("hub.store.storeinfo.address1")}
			value={formattedAddress2 || ""}
		>
			<div slot="input" class="autocomplete" t-id="numb">
				<AutoComplete
					noFocusoutline={false}
					inputBackgroundColor={autocompleteBackground}
					searchCallback={autoCompleteHandler("numb")}
					search={formattedAddress2 || ""}
				/>
			</div>
		</StoreNameValue>
	</div>
	<div class="name-value">
		<StoreNameValue
			editmode={editmode}
			name={$t("hub.store.storeinfo.address2")}
			value={formattedAddress1 || ""}
		>
			<div slot="input" class="autocomplete" t-id="road">
				<AutoComplete
					noFocusoutline={false}
					inputBackgroundColor={autocompleteBackground}
					searchCallback={autoCompleteHandler("road")}
					search={formattedAddress1 || ""}
				/>
			</div>
		</StoreNameValue>
	</div>
	<div class="name-value">
		<StoreNameValue
			name={$t("hub.store.storeinfo.address_detailed")}
			bind:value={detailAddress}
			editmode={editmode}
		/>
	</div>
	<div class="name-value">
		<StoreNameValue
			description={$t("hub.store.storeinfo.Lock_tooltip")}
			name={$t("hub.store.storeinfo.Store_Infomation_Lock")}
			value={appLockEnabled
				? $t("hub.store.widget.cashreceipt.enabled")
				: $t("hub.store.widget.cashreceipt.disabled")}
			editmode={editmode}
		>
			<div slot="input" class="lock-box">
				<DefaultSwitch bind:checked={appLockEnabled} />
			</div>
		</StoreNameValue>
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;

		.autocomplete {
			background-color: #f0f0f4;
			border-radius: 5px;
		}
		.dummy {
			display: none;
		}
	}
	@include DesktopSize {
		.container {
			flex-direction: row;
			flex-wrap: wrap;
			gap: 30px 0px;

			.dummy {
				display: flex;
			}

			.name-value {
				width: 50%;
				max-width: 50%;
			}

			.autocomplete {
				max-width: calc(100% - 40px);
			}

			.lock-box {
				display: flex;
				align-items: center;
				height: 40px;
			}
		}
	}
</style>
